export default __webpack_public_path__ + "static/media/onsite-training.c397b1a2.jpg";